import { Flex, Text, Image, Box, SimpleGrid, Link } from "@chakra-ui/react";

const Component = () => {
  return (
    <Flex
      bottom={0}
      left={0}
      right={0}
      width={"100%"}
      height={"180px"}
      padding={"40px 0px"}
      background={"rgba(29, 29, 29, 0.80)"}
      justifyContent={"center"}
    >
      <Flex
        width={{base: "100%", md: "1116px"}}
        padding={"0px 30px"}
        direction={"row"}
        justifyContent={"space-between"}
        alignItems={"center"}
      >
        <Flex direction={"row"} alignItems={"center"} pr={"8px"}>
          <Image src="/logo.svg" alt="Logo" height="100px" />
          <Flex direction={"column"} ml={"40px"}>
            <Text color={"#DBDBDB"} fontSize={{base: "12px", md: "16px"}} fontWeight={"400"}>
              socialproject.pl © 2025 All rights reserved
            </Text>
            <Text color={"#DBDBDB"} fontSize={{base: "12px", md: "16px"}} fontWeight={"400"}>
              Designed by <Link href="https://www.behance.net/dannyoo" target="_blank">D4NNV</Link> & Skyline
            </Text>
            <Text color={"#DBDBDB"} fontSize={{base: "12px", md: "16px"}} fontWeight={"400"}>
                Developed by <Link href="https://destriusz.github.io" target="_blank">Destriusz</Link> with ❤️
            </Text>
          </Flex>
        </Flex>
        <SimpleGrid columns={{base: 2, md: 4}} gap={"17px"}>
          <Box
            width="32px"
            height="32px"
            bgColor="#fff"
            borderRadius="50%"
            padding="4px"
            as={Link}
            href="https://discord.socialproject.pl"
            target="_blank"
          >
            <Image
              src="/Discord.svg"
              alt="Discord"
              width="24px"
              height="24px"
            />
          </Box>
          <Box
            width="32px"
            height="32px"
            bgColor="#fff"
            borderRadius="50%"
            padding="4px"
            as={Link}
            href="https://www.youtube.com/@Socialprojectpl"
            target="_blank"
          >
            <Image
              src="/Youtube.svg"
              alt="Youtube"
              width="24px"
              height="24px"
            />
          </Box>
          <Box
            width="32px"
            height="32px"
            bgColor="#fff"
            borderRadius="50%"
            padding="4px"
            as={Link}
            href="https://www.instagram.com/socialproject.pl"
            target="_blank"
          >
            <Image
              src="/Instagram.svg"
              alt="Instagram"
              width="24px"
              height="24px"
            />
          </Box>
          <Box
            width="32px"
            height="32px"
            bgColor="#fff"
            borderRadius="50%"
            padding="4px"
            as={Link}
            href="https://www.tiktok.com/@socialprojectpl"
            target="_blank"
          >
            <Image
              src="/Tiktok.svg"
              alt="Tiktok"
              width="24px"
              height="24px"
            />
          </Box>
        </SimpleGrid>
      </Flex>
    </Flex>
  );
};

export default Component;
